var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scrollbar-inner" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("h4", { staticClass: "h3 mb-0" }, [_vm._v(_vm._s(_vm.title))]),
      ]),
      _c("div", { staticClass: "card-header py-0" }, [
        _c("form", [
          _c("div", { staticClass: "form-group mb-0" }, [
            _c(
              "div",
              { staticClass: "input-group input-group-lg input-group-flush" },
              [
                _vm._m(0),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.queryText,
                      expression: "queryText",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "search",
                    placeholder: "Search",
                    "aria-label": "Example text with two button addons",
                    "aria-describedby": "button-addon3",
                  },
                  domProps: { value: _vm.queryText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.queryText = $event.target.value
                    },
                  },
                }),
              ]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "card-body px-2 py-3" }, [
        _c(
          "ul",
          { staticClass: "list-group list-group-flush list my--3" },
          _vm._l(_vm.filteredUsers, function (user, ind) {
            return _c("li", { key: ind, staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-0" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      user.image
                        ? _c("img", {
                            attrs: {
                              alt: "Image placeholder",
                              src: user.image,
                            },
                          })
                        : _c("span", [
                            _vm._v(_vm._s(user.first_name.substring(0, 1))),
                          ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v(
                        _vm._s(user.first_name) + " " + _vm._s(user.last_name)
                      ),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked:
                          _vm.sideBarUser && _vm.sideBarUser.id == user.id,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.onUserSelected(user)
                        },
                      },
                    }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("div", { staticClass: "input-group-text" }, [
        _c("span", { staticClass: "fas fa-search" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }